import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, GFunc, LocaleX, ZMath, ZTime } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, Spacer, VStack, XIconButton, XScroll, XText } from "IZOX/_X";
import { TbPhoto } from "react-icons/tb";
import _ from "lodash";
import ReceiptUtils from "../_utils/ReceiptUtils";

/**
 * @augments {Component<Props, State>}
 */
class ReceiptRowM extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(ReceiptRowM.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  render(){
    let {doc} = this.props;
    let {_id, policyNo, createdAt, amount, attachments, status, preventPublish} = doc ?? {};
    let _status = ReceiptUtils.GetStatus(status);
    if(preventPublish) return null;
    return (
      <VStack fullWidth p={8} bgColor={ColorX.CSS("BgLeaf")}>
        <HStack>
          <VStack fullWidth HAlign="[">
            <XText fontSize={12}>
              {ZTime.Moment(createdAt).format("DD/MM/YYYY - HH:mm")}
            </XText>
            <HStack spacing={5} HAlign="[">
              <XText fontSize={12} color={ColorX.CSS("Leaf")}>
                {LocaleX.Parse({
                  EN: "Receipt No.",
                  TC: "收據編號"
                })}
              </XText>
              <XText fontSize={14} bold color={ColorX.CSS("Leaf")}>
                {`#${policyNo ?? _id}`}
              </XText>
              <XText fontSize={16} bold color={ColorX.CSS("Leaf")}>
                {` - $${ZMath.NumberWithCommas(amount)}`}
              </XText>
            </HStack>
          </VStack>
          <Spacer/>
          {(status === "Submitted" || status === "Unpaid" || status === "Rejected") &&
            <HStack pH={20} fitWidthToContent bgColor={_status?.bgColor} flexShrink={0}>
              <XText fontSize={12} color={_status?.color} noWrap>
                {LocaleX.Parse(_status?.label)}  
              </XText>  
            </HStack>}
        </HStack>
        <XScroll>
          <HStack HAlign="[" width={(attachments?.length ?? 0) * 35} mH={10} spacing={5}>
            {_.map(attachments, (o, i) => {
              return (
                <XIconButton bgColor={ColorX.CSS("ActiveBg")} padding={5} key={i}
                  onPress={() => GFunc.ViewIZOXImage(o)}>
                  <TbPhoto color={ColorX.CSS("Active")}/>
                </XIconButton>
              );
            })}
          </HStack>
        </XScroll>
      </VStack>
    );
  }

}

export default observer(ReceiptRowM);
